import type { CanonicalEnvironment } from "../../shared/environment";

import { createContext, useContext } from "react";

interface AceContext {
  accountId: string | null | undefined;
  isLoggedIn?: boolean | null;
  proctorGroups?: string | null;
  buildEnvironment?: CanonicalEnvironment | null;
  /**
   * Web / embedded chat: base URL for Career Scout API (no trailing slash).
   * When set, CSAPI hooks use this instead of `getCareerScoutApiBaseUrl(buildEnvironment)`.
   */
  careerScoutApiBaseUrl?: string | null;
  /**
   * Web / embedded chat: base URL for AI Core (no trailing slash).
   * When set, AI Core callers use this instead of `getAICoreApiBaseUrl(buildEnvironment)`.
   */
  aiCoreApiBaseUrl?: string | null;
  /**
   * Web / embedded chat: optional `fetch` used for Career Scout API + AI Core HTTP.
   * When set, overrides `createNativeFetch` so the host can attach auth or call a BFF.
   */
  careerScoutFetch?: typeof fetch | null;
}

export const AceContext = createContext<AceContext>({
  accountId: "",
  isLoggedIn: null,
  buildEnvironment: null,
});
export const useAceContext = () => useContext(AceContext);
